import { i18n } from '../i18n'

export const getEditOrgLink = (
  orgId: string,
  RelayState: string = window.location.href
) => {
  const locale = i18n.language
  return `/yhteisopalvelu/${locale}/organisations/${orgId}?RelayState=${encodeURIComponent(
    RelayState
  )}`
}

export const getCreateOrgLink = (RelayState: string = window.location.href) => {
  const locale = i18n.language
  return `/yhteisopalvelu/${locale}/organisations/create?RelayState=${encodeURIComponent(
    RelayState
  )}`
}
